// Unresolved task list dashboard and its work-item exports.
import {
  UnresolvedTaskListChainSnapshot,
  UnresolvedTaskListDashboardResponse,
  UnresolvedTaskListFilter,
  UnresolvedTaskListWorkItemsResponse,
} from '../../types/unresolvedTaskList';
import { forgeBlobRequest, forgeRequest } from '../forgeRequest';
import { FORGE_DASHBOARDS_API_URL, FORGE_UNRESOLVED_TASK_LIST_API_URL } from './endpoints';

export async function fetchUnresolvedTaskList(
  token: string
): Promise<UnresolvedTaskListDashboardResponse> {
  return forgeRequest<UnresolvedTaskListDashboardResponse>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/unresolved-task-list`,
    'Error fetching Unresolved task list',
    { dedupeKey: ['fetchUnresolvedTaskList', token] }
  );
}

export async function refreshUnresolvedTaskList(
  token: string,
  chainId: number
): Promise<UnresolvedTaskListChainSnapshot> {
  return forgeRequest<UnresolvedTaskListChainSnapshot>(
    token,
    `${FORGE_DASHBOARDS_API_URL}/unresolved-task-list/refresh`,
    'Error refreshing Unresolved task list snapshot',
    {
      method: 'POST',
      body: {
        chain_id: chainId,
      },
    }
  );
}

export async function fetchUnresolvedTaskListWorkItems(
  token: string,
  params?: {
    chainId?: number | null;
    unresolvedFilter?: UnresolvedTaskListFilter;
    page?: number;
    limit?: number;
    signal?: AbortSignal;
  }
): Promise<UnresolvedTaskListWorkItemsResponse> {
  const query = new URLSearchParams();
  if (params?.chainId) query.set('chain_id', String(params.chainId));
  if (params?.unresolvedFilter) query.set('unresolved_filter', params.unresolvedFilter);
  if (params?.page !== undefined) query.set('page', String(params.page));
  if (params?.limit !== undefined) query.set('limit', String(params.limit));
  return forgeRequest<UnresolvedTaskListWorkItemsResponse>(
    token,
    `${FORGE_UNRESOLVED_TASK_LIST_API_URL}/work-items${query.toString() ? `?${query.toString()}` : ''}`,
    'Error fetching Unresolved task list work items',
    { signal: params?.signal }
  );
}

export async function exportUnresolvedTaskListWorkItems(
  token: string,
  params?: { chainId?: number | null; unresolvedFilter?: UnresolvedTaskListFilter }
): Promise<{ blob: Blob; filename: string }> {
  const query = new URLSearchParams();
  if (params?.chainId) query.set('chain_id', String(params.chainId));
  if (params?.unresolvedFilter) query.set('unresolved_filter', params.unresolvedFilter);
  return forgeBlobRequest(
    token,
    `${FORGE_UNRESOLVED_TASK_LIST_API_URL}/work-items/export${query.toString() ? `?${query.toString()}` : ''}`,
    'Error exporting Unresolved task list work items',
    'unresolved-task-list-work-items.csv'
  );
}
